import * as React from 'react';
import { whiteLocaleList, euLocaleList } from '@/constants/appreciationDay';
import AppreciationDay from '@/components/EcoCredits/AppreciationDay';
import getLocal from '@/app/utils/getLocal';
import Appre from './Appre';
import AppreContext, { StageRangeType } from './context';
import { useGlobal } from '@/utils/useGlobal';

const { useState, useEffect } = React;
export interface MixAppreciationDayProps {
    isLogin: boolean;
}

export const euStageTimeLine = {
    stage1: new Date('2024/08/19 15:00:00 GMT+8').getTime(), // 阶段一
    stage2: new Date('2024/08/22 15:00:00 GMT+8').getTime(), // 阶段二
    stage3: new Date('2024/08/25 15:00:00 GMT+8').getTime(), // 阶段三 结束活动的阶段或者还未开始 8.25 15:00:00 - 9.19 14:59:59
};

// export const euStageTimeLine = {
//     stage1: new Date('2024/03/19 15:00:00 GMT+8').getTime(), // 阶段一
//     stage2: new Date('2024/07/10 15:00:00 GMT+8').getTime(), // 阶段二
//     stage3: new Date('2024/08/18 15:00:00 GMT+8').getTime(), // 结束活动的阶段或者还未开始 8.25 15:00:00 - 9.19 14:59:59
// };

const MixAppreciationDay: React.FC<MixAppreciationDayProps> = ({ isLogin }) => {
    const { locale } = getLocal();
    const { getSystemTime, useRouter } = useGlobal();
    const { query } = useRouter();

    const [stage, setStage] = useState(StageRangeType.stage3);

    const time = getSystemTime();

    useEffect(() => {
        let stg = StageRangeType.stage3;
        // if (time < euStageTimeLine.stage1 || time > euStageTimeLine.stage3) {
        //     setStage(StageRangeType.stage3);
        // } else if (time > euStageTimeLine.stage2) {
        //     setStage(StageRangeType.stage2);
        // } else if (time > euStageTimeLine.stage1) {
        //     setStage(StageRangeType.stage1);
        // }

        if (time >= euStageTimeLine.stage2 && time < euStageTimeLine.stage3) {
            stg = StageRangeType.stage2;
        } else if (time >= euStageTimeLine.stage1 && time < euStageTimeLine.stage2) {
            stg = StageRangeType.stage1;
        }

        // convenient for test
        if (query && query?.appre) {
            stg = query?.appre;
        }

        setStage(stg);
    }, [time, query]);

    if (euLocaleList.includes(locale) && stage !== StageRangeType.stage3) {
        return (
            <AppreContext value={{ stage, isLogin }}>
                <Appre />
            </AppreContext>
        );
    }

    return <>{whiteLocaleList.includes(locale as string) && <AppreciationDay />}</>;
};

export default MixAppreciationDay;
